import { CSSProperties } from 'react';
import { observer } from 'mobx-react';
import cls from 'classnames';

import FancyInput from '@/common/components/inputs/FancyInput/FancyInput';
import FormGroup from '@/common/components/inputs/FormGroup/FormGroup';
import RichText from '@/common/components/RichText/RichText';
import ForwardPreview from '@/forwarding/components/ForwardPreview/ForwardPreview';
import { useForwardPreviewMediaSize } from '@/forwarding/hooks/useForwardPreviewMediaSize';
import { ForwardPreviewData } from '@/forwarding/types/ForwardPreviewData';
import { MEDIA_SIZE_MAP } from '@/media/constants/sizeCodeToPx';

import styles from './ForwardPreviewHeader.module.css';

export interface ForwardPreviewHeaderProps {
  preview: ForwardPreviewData;
  title: string;
  description?: string;
  isVertical?: boolean;
  className?: string;
}

function ForwardPreviewHeader(props: ForwardPreviewHeaderProps) {
  const { preview, title, description = '', isVertical = false, className } = props;

  const mediaSize = useForwardPreviewMediaSize();

  return (
    <div
      className={cls(styles.forwardPreviewHeader, { [styles.vertical]: isVertical }, className)}
      style={{ '--mediaSize': `${MEDIA_SIZE_MAP[mediaSize]}px` } as CSSProperties}
    >
      <ForwardPreview preview={preview} mediaSize={mediaSize} />

      <div className={styles.info}>
        <FormGroup>
          <FancyInput
            name="title"
            aria-label="Forward title"
            value={title}
            className={cls(styles.titleInput, styles.inputContent)}
            contentClassName={styles.inputContent}
            readOnly
          />
        </FormGroup>

        {!!description && (
          <FormGroup className={styles.descriptionFormGroup}>
            <RichText value={description} className={styles.description} aria-label="Forward description" />
          </FormGroup>
        )}
      </div>
    </div>
  );
}

export default observer(ForwardPreviewHeader);
